import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../components/Link';
import { formatNumber, getDecimals } from '../../service/market';
import { tickerColumns } from '../../service/tickercolumns';
import MdChevronRight from 'react-icons/lib/md/chevron-right';
import MdExpandMore from 'react-icons/lib/md/expand-more';
import TickerGraph from '../../components/graph/TickerGraph';
import table from '../../styles/table/flextable';
import css from '../../styles/table/indexrow';


// @TODO: Combine methods, i.e. renderLast and renderChange
export default class IndexRow extends Component {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        symbol: PropTypes.string,
        price_usd: PropTypes.string,
        percent_change_24h: PropTypes.string,
        image: PropTypes.string,
        subtitle: PropTypes.string,
        onClick: PropTypes.func,
        expand: PropTypes.bool,
        columns: PropTypes.number,
        breakpoint: PropTypes.string,

        CLOSE_CA_BEGIN_1DAY: PropTypes.number,
        CLOSE_BEGIN_1DAY: PropTypes.number,
        TIME: PropTypes.number,
        LONG_NAME: PropTypes.string,
        SECURITYNAME: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        CHANGE: PropTypes.number,
        CHANGE_PCT: PropTypes.number,
        CHANGE_7DAYS: PropTypes.number,
        CHANGE_7DAYS_PCT: PropTypes.number,
        CHANGE_MONTH: PropTypes.number,
        CHANGE_MONTH_PCT: PropTypes.number,
        CHANGE_1YEAR: PropTypes.number,
        CHANGE_1YEAR_PCT: PropTypes.number,

        requestTickerData: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = ({
            sign: css.neutral,
            toggled: false,
            graphLoaded: false,
        });

        this._setSign = p => {
            const { CHANGE, CHANGE_PCT } = p;

            const change = CHANGE || CHANGE_PCT;

            let sign;
            if (change) {
                sign = change >= 0 ? css.positive : css.negative;
            } else {
                sign = css.neutral;
            }

            this.setState({ sign });
        };

        this.rangeOptions = ['today', 'oneWeekAgo', 'oneMonthAgo', 'oneYearAgo'];

        this._rowClick = this._rowClick.bind(this);

        this._stopPropagation = e => e.stopPropagation();
    }

    componentDidMount() {
        this._setSign(this.props);

        this.props.requestTickerData(this.props.symbol, tickerColumns);
    }

    componentWillReceiveProps(nextProps) {
        this._setSign(nextProps);
    }

    _rowClick() {
        this.props.onClick(this.props.symbol);
    }

    renderName() {
        // @TODO: Fallback for names
        if (this.props.expand) {
            return (
                <div
                    className={[css.alignLeft, table.tableCell].join(' ')}
                    onClick={this._rowClick}
                >
                    <span className={css.chevron}>
                        <MdExpandMore />
                    </span>
                    <Link
                        className={css.hiddenLink}
                        to={`/instrument/${encodeURIComponent(this.props.symbol).toUpperCase()}`}
                        onClick={this._stopPropagation}
                    >
                        <span className={css.name}>
                            {this.props.LONG_NAME || this.props.SECURITYNAME}
                        </span>
                    </Link>
                </div>
            );
        }

        return (
            <div
                className={[css.alignLeft, table.ellipsis, table.tableCell].join(' ')}
                onClick={this._rowClick}
            >
                <span className={css.chevron}>
                    <MdChevronRight />
                </span>
                <span className={css.name}>
                    {this.props.LONG_NAME || this.props.SECURITYNAME}
                </span>
            </div>
        );
    }

    renderLast() {
        const { LAST, LASTNZ } = this.props;

        const decimals = getDecimals(LAST || LASTNZ);

        return (
            <div
                className={[css.last, table.tableCell].join(' ')}
                onClick={this._rowClick}
            >
                <span>{formatNumber(LAST || LASTNZ, decimals)}</span>
            </div>
        );
    }

    renderChange() {
        if (this.props.columns <= 3) {
            return null;
        }

        const { CHANGE } = this.props;

        const decimals = getDecimals(CHANGE);

        return (
            <div
                className={[this.state.sign, table.tableCell, table.change].join(' ')}
                onClick={this._rowClick}
            >
                <span>{formatNumber(CHANGE, decimals)}</span>
            </div>
        );
    }

    renderChangePct() {
        return (
            <div
                className={[this.state.sign, table.tableCell, table.change].join(' ')}
                onClick={this._rowClick}
            >
                <span>{formatNumber(this.props.CHANGE_PCT, 2, true)}</span>
            </div>
        );
    }

    renderTickerGraph() {
        return (
          <TickerGraph
              key={this.props.symbol}
              symbol={this.props.symbol}
              height={140}
              close={this.props.CLOSE_CA_BEGIN_1DAY || this.props.CLOSE_BEGIN_1DAY}
              rangeOptions={this.rangeOptions}
              CHANGE_PCT={this.props.CHANGE_PCT}
              CHANGE_7DAYS={this.props.CHANGE_7DAYS}
              CHANGE_7DAYS_PCT={this.props.CHANGE_7DAYS_PCT}
              CHANGE_MONTH={this.props.CHANGE_MONTH}
              CHANGE_MONTH_PCT={this.props.CHANGE_MONTH_PCT}
              CHANGE_1YEAR={this.props.CHANGE_1YEAR}
              CHANGE_1YEAR_PCT={this.props.CHANGE_1YEAR_PCT}
              LAST={this.props.LAST}
              TIME={this.props.TIME}
          />
        );
    }

    render() {
        let className = [css.indexRow, table.tableRow];
        if (this.props.expand) {
            className = [css.indexRow, table.tableRow, css.toggled];
        }

        return (
            <li className={className.join(' ')}>
                <div>
                    {this.renderName()}
                    {this.renderLast()}
                    {this.renderChange()}
                    {this.renderChangePct()}
                </div>
                {this.props.expand ? (
                    <div className={css.graphContainer}>
                        {this.renderTickerGraph()}
                    </div>
                ) : '' }
            </li>
        );
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/components/table/IndexRow.js
 **/